import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import {LessonsByInstructorReportComponent } from './';

export const USERS_FINANTIAL_STATUS_REPORT_ROUTE: Route = {
    path: 'lessons-by-instructor-report',
    data: {
        authorities: ['ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.lessons-by-instructor-report.title'
    },
    component: LessonsByInstructorReportComponent,
    canActivate: [ UserRouteAccessService ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/lessons-by-instructor-report/lessons-by-instructor-report-component.route.ts